<template>
  <div class="purchase-card-cont flex flex-column">
    <div class="back-btn-cont">
      <ButtonVue
        label="<i class='material-symbols-outlined'>arrow_back</i> Back"
        type="invisible"
        @btn-click="$router.go(-1)">
      </ButtonVue>
    </div>

    <LoadingWidget v-if="loading" type="bar" ref="loading"></LoadingWidget>

    <div v-else class="purchase flex flex-column block">
      <div class="purchase-line-data flex flex-center">
        <div class="primary-text purchase-date">{{formattedDate}}</div>
        <div class="primary-text purchase-amount child-right">{{formattedAmount}}</div>
      </div>

      <div class="purchase-tags">
        <div class="flex">
          <TagVue v-for="tag in model.tags" :key="tag.id" :tagLabel="tag.label" :readOnly="true" />
        </div>
      </div>

      <div class="child-left flex">
        <div class="flex purchase-business">
          <span>Business:</span>
          <router-link :to="{ name: 'business', params: {id:model.business.id} }">
            <span class="link">{{model.business.name}}</span>
          </router-link>
        </div>

        <div class="flex purchase-category">
          <span>Category:</span>
          <router-link :to="{ name: 'category', params: {id: model.category.id} }">
            <span class="link">{{model.category.name}}</span>
          </router-link>
        </div>
      </div>
      
      <div class="purchase-details" ref="details">
        <div class="purchase-desc">{{model.desc}}</div>
      </div>

      <div class="purchase-controls flex gap-12">
        <ButtonVue
          label="<i class='material-symbols-outlined'>delete</i> Delete"
          type="danger"
          @btn-click="deletePurchase">
        </ButtonVue>

        <ButtonVue
          label="<i class='material-symbols-outlined'>edit</i> Edit"
          @btn-click="editPurchase">
        </ButtonVue>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonVue from '@Common/components/ButtonCompVue'
import LoadingWidget from '@Common/elements/LoadingWidget'
import TagVue from '@Common/components/TagVue'

import { getUrl } from '@/utils/fetch_helpers'
import { formatAmount } from '@/utils/formatting'

const PURCHASE_URL = `${process.env.VUE_APP_PIPES}/finances/purchases/`

export default {
  name: 'PurchaseItem',

  props: ['id'],

  data () {
    return {
      modelId: this.$route.params.id,
      model: undefined,
      loading: true,
    }
  },

  computed: {
    formattedDate() {
      const d = this.$moment(this.model.date, 'YYYY-MM-DD')
      return d.format('dddd, MMMM Do YYYY')
    },

    formattedAmount() {
      return formatAmount(this.model.amount)
    },
  },

  methods: {
    fetchModel() {
      return getUrl(`${PURCHASE_URL}${this.modelId}/`)
    },

    deletePurchase() {
    },

    editPurchase() {
    },
  },

  created() {
    this.fetchModel().then(r => {
      this.model = r;
      this.loading = false;
    })
  },

  components: {
    LoadingWidget,
    ButtonVue,
    TagVue,
  },
}
</script>

<style lang="scss">
.purchase-card-cont {
  width: 100%;
  max-width: 800px;
  margin-bottom: $margin;

  .purchase {
    width: 100%;
    margin: $margin 0;

    .purchase-line-data {
      .purchase-amount {
      }
    }

    .purchase-tags {
      margin: $marginSmall 0;
    }

    .purchase-business,
    .purchase-category {
      font-weight: $bold;
      margin-right: $marginSmall;

      .link {
        margin-left: 4px;
      }
    }

    .purchase-details {
      transition: all 0.5s;

      :first-child {
        padding-top: $padding;
      }
    }

    .purchase-controls {
      margin-left: auto;
    }
  }
}
</style>
